import { UserPreferences, WheelchairConstraints } from '../types';

const defaultWheelchairConstraints: WheelchairConstraints = {
  avoidStairs: true,
  avoidSteepSlopes: true,
  preferWidePaths: true,
  avoidCobblestones: true,
  requireElevators: false,
  maxSlopeAngle: 5,
  minPathWidth: 1.5,
};

const defaultRoutePreferences = {
  routeType: 'balanced' as const,
  pathPreference: 'no-preference' as const,
  publicTransportPreference: 'no-preference' as const,
  activePreferences: ['fastest', 'bikepaths', 'accessiblePT'],
  preferenceOrder: ['fastest', 'bikepaths', 'accessiblePT', 'sidewalks', 'beautiful'],
};

export const defaultUserPreferences: UserPreferences = {
  wheelchairConstraints: defaultWheelchairConstraints,
  wheelchairSpecs: [],
  routePreferences: defaultRoutePreferences,
  preferredLanguage: 'nl',
  units: 'metric',
  voiceGuidance: false,
  highContrast: false,
  fontSize: 'medium',
  hasCompletedOnboarding: false,
  hasCompletedPreferenceOnboarding: true,
};
